import type { DeliveryMode } from './types'

/**
 * ¿Se acepta un `onQuote` que llega del mini-sheet de dirección?
 * Puro a propósito: el padre lo evalúa con REFS (no con el closure del render),
 * porque la respuesta llega después de un await y el estado pudo cambiar.
 */
export function shouldAcceptQuote(s: { deliveryMode: DeliveryMode; addressSheetOpen: boolean }): boolean {
  return s.deliveryMode === 'delivery' && s.addressSheetOpen
}
